module.exports = __webpack_public_path__ + "static/img/left-logo.3f023b6b.png";